import React from "react";

interface PhoneRowProps {
  numbers: string[]
}

export const PhoneRow = (props: PhoneRowProps) => {
  return <div>
    {props.numbers.map((phoneNr, idx) => <div key={`${phoneNr}-${idx}`}>
      <div><a href={`tel:${phoneNr}`}>{phoneNr}</a></div>
    </div>)}
  </div>
};

export default PhoneRow;